// extracted by mini-css-extract-plugin
export default {"list":"plays-to-delete-dialog_list__O0tvM"};